import { render, staticRenderFns } from "./NoticeReg.vue?vue&type=template&id=15e01326&scoped=true"
import script from "./NoticeReg.vue?vue&type=script&lang=js"
export * from "./NoticeReg.vue?vue&type=script&lang=js"
import style0 from "./NoticeReg.vue?vue&type=style&index=0&id=15e01326&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e01326",
  null
  
)

export default component.exports